import React from 'react'
import { Grid } from '@mui/material'
import { useFormFactor } from '../../../../../../../hooks'

const StepPageContainer = ({ children }) => {
  const { isMobile, isSmallTablet } = useFormFactor()
  const isSmallScreen = isMobile || isSmallTablet
  return (
    <Grid container spacing={isSmallScreen ? 4 : 7}>
      {children}
    </Grid>
  )
}

export default StepPageContainer
